// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__NjMd5","texts":"footer_texts__aMHga","image":"footer_image__Y0tTg","links":"footer_links__sRCmB"};